import React from "react";
import { Facebook, ExternalLink, Camera, Tag, Wrench } from "lucide-react";
import { businessInfo } from "../mock";

const FB_PAGE_URL = businessInfo.social.facebook;

const highlights = [
  { icon: Wrench, text: "Πραγματικές επισκευές από τον πάγκο μας" },
  { icon: Tag, text: "Προσφορές και εκπτώσεις πρώτα εκεί" },
  { icon: Camera, text: "Φωτογραφίες πριν και μετά" },
];

const FacebookFeed = () => (
  <section id="facebook" className="py-24 relative" data-testid="facebook-section">
    <div className="absolute inset-0 circuit-dots opacity-20 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
      <div className="reveal pcb-card p-8 md:p-12 grid lg:grid-cols-[1.2fr_1fr] gap-10 items-center">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-emerald-300/80">Social</div>
          <h2 className="mt-2 text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight">
            Ακολουθήστε μας στο <span className="text-emerald-400">Facebook</span>
          </h2>
          <p className="mt-4 text-emerald-50/70 max-w-md">
            Εκεί ανεβάζουμε τις επισκευές της ημέρας, νέα από το κατάστημα και
            προσφορές.
          </p>
          <ul className="mt-6 space-y-3">
            {highlights.map(({ icon: Icon, text }) => (
              <li key={text} className="flex items-center gap-3 text-emerald-50/80 text-sm">
                <Icon className="w-4 h-4 text-emerald-400" /> {text}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col items-start lg:items-center gap-5">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-xl bg-emerald-500/10 border border-emerald-500/40 flex items-center justify-center">
              <Facebook className="w-8 h-8 text-emerald-400" />
            </div>
            <div>
              <div className="text-white font-semibold text-lg">{businessInfo.name}</div>
              <div className="text-xs text-emerald-300/80">Επίσημη σελίδα στο Facebook</div>
            </div>
          </div>
          <a
            href={FB_PAGE_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="facebook-visit-page-btn"
            className="btn-primary rounded-md px-6 py-3 inline-flex items-center gap-2 text-sm"
          >
            Ακολουθήστε τη σελίδα <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default FacebookFeed;
